//
//
//
//
//
//
//
//

import baiduStatistics from './baidu_gongda'
import { mapActions, mapGetters } from 'vuex'
import Toast from './components/toast.vue'
import {trackEvent} from './umeng.js'
import { listener, interval } from '@/mixin'
export default {
  name: 'App',
  components: {Toast},
  mixins: [listener, interval],
  data () {
    return {
      screenHeight: '',
      user: ''
    }
  },
  destroyed () {
    // window.removeEventListener('focusout', this.fixScrollTop)
  },
  mounted () {
    // this.$addEventListener(window, 'focusout', this.fixScrollTop)
    this.getIp()
    // window.addEventListener('focusout', this.fixScrollTop)
    // 工大百度统计
    if (this.$parent.$parent === undefined) {
      if (this.$route.params && this.$route.params.collegeID === '49') {
        baiduStatistics()
      }
    }
  },
  computed: {
    ...mapGetters(['college', 'isLogin'])
  },
  methods: {
    ...mapActions(['fetchCollegeInfo', 'loginFromSWYT', 'logger', 'getIp']),
    // fixScrollTop () {
    //   setTimeout(() => {
    //     document.body.scrollTop = document.body.scrollHeight
    //   }, 0)
    // },
    // 判断设备型号，获取不同设备的高度
    fetchScreenHeight () {
      if (/Android|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
        this.screenHeight = document.documentElement.clientHeight + 'px'
        console.log(this.screenHeight)
      } else {
        this.screenHeight = '736px'
        console.log(this.screenHeight)
      }
    },
    getData () {
      console.log(this.$parent)
      // App组件作为根组件
      if (this.$parent.$parent.$parent === undefined) {
        console.log('root app created')
        if (this.$route.params) {
          console.log(this.$route.params)
          this.fetchCollegeInfo(this.$route.params.collegeID).then(() => {
            console.log('fetchCollegeInfo done')
            document.title = this.college.uName + this.college.name
            trackEvent({
              category: '页面',
              action: '访问',
              label: `学校:${this.college.uName},实例:${this.college.indexInstanceID},标题:${this.college.name}`
            })
            // this.logger({name: this.college.uName, biz: this.college.id})
            if (this.$route.query.user !== undefined) {
              this.user = decodeURIComponent(window.atob(this.$route.query.user))
              this.loginFromSWYT(JSON.parse(this.user))
            }
            if (this.$route.name === 'index') {
              this.$router.replace({
                name: `class${this.college.indexClassID}`,
                params: {
                  instanceID: this.college.indexInstanceID
                }
              })
              // this.$router.go({
              //  path: 'class' + this.college.indexClassID + '/' + this.college.indexInstanceID,
              //  append: true,
              //  replace: true
              // })
            }
          })
        }
        this.fetchScreenHeight()
      } else {
        // App组件作为跳转首页组件
        console.log('jump app created')
      }
    }
  },
  watch: {
    '$route': {
      immediate: true,
      async handler () {
        await this.getData()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/App.vue